import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {useSlider} from '@aboutyou/ui-components';
import {useEffect, useRef} from 'react';
import {getCouponPromotionId} from '../../../../../../features/Coupons/getCouponPromotionId';

export const useScrollToActiveCoupon = ({
  coupons,
  couponPromotionId,
}: {
  coupons: Coupon[];
  couponPromotionId?: string | null;
}) => {
  const scrollWrapperRef = useRef<HTMLUListElement>(null);
  const {scrollToSlide} = useSlider(scrollWrapperRef);
  const activeCouponIndex = (coupons || []).findIndex(
    coupon => getCouponPromotionId(coupon) === couponPromotionId,
  );

  useEffect(() => {
    if (activeCouponIndex > -1) {
      scrollToSlide(activeCouponIndex, {
        sliderGap: 8,
      });
    }
  }, [activeCouponIndex]);

  return {scrollWrapperRef};
};
